// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryTile_root__285LE","image":"CategoryTile_image__37xBx","name":"CategoryTile_name__1C23b","tile_link":"CategoryTile_tile_link__358xo"};